<template>
    <div class="page-box fix" v-bind:class="{center: placement === 'center'}">
        <div class="page-wrap" v-bind:class="{l: placement === 'left', r: placement === 'right'}">
            <a class="page-ele prev-page" v-bind:class="{disabled: current === 1}" href="javascript: void(0)" @click="setCurrent(current - 1)">&lt; 上一页</a>
            <ul>
                <li v-for="(item, index) in pageList" :key="index" v-bind:class="{cur: current === item.val}" @click="setCurrent(item.val)">{{item.txt}}</li>
            </ul>
            <a class="page-ele next-page" v-bind:class="{disabled: current === pages}" href="javascript: void(0)" @click="setCurrent(current + 1)">下一页 &gt;</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',
        props: {
            size: {
                type: Number,
                default: 10
            },
            total: {
                type: Number,
                default: 0
            },
            current: {
                type: Number,
                default: 1
            },
            pageGroup: {
                type: Number,
                default: 9
            },
            placement: {
                type: String,
                default: 'left',
            },
        },
        computed: {
            pages () {
                let pages = Math.ceil(this.total / this.size)
                pages = pages <= 0 ? 1: pages
                return pages
            },
            pageList () {
                let len = this.pages,
                    count = Math.floor(this.pageGroup / 2),
                    center = this.current,
                    temp = [],
                    list = []
                if(len <= this.pageGroup){
                    while(len--){
                        temp.push({
                            txt: this.pages - len,
                            val: this.pages - len
                        })
                    }
                    return temp
                }
                while (len--) {
                    temp.push(this.pages - len)
                }
                let idx = temp.indexOf(center)
                if (idx < count) {
                    center = center + count - idx
                }
                if (this.current > this.pages - count) {
                    center = this.pages - count
                }
                temp = temp.splice(center - (count - 2) - 1, this.pageGroup - 4)
                do {
                    let t = temp.shift()
                    list.push({
                        txt: t,
                        val: t
                    })
                } while (temp.length)
                if (this.pages > this.pageGroup) {
                    if (this.current > count + 1) {
                        list.unshift({txt: '...', val: list[0].val - 1})
                    } else {
                        list.unshift({txt: 2, val: 2})
                    }
                    if (this.current < this.pages - count) {
                        list.push({txt: '...', val: list[list.length - 1].val + 1})
                    } else {
                        list.push({txt: this.pages - 1, val: this.pages - 1})
                    }
                    // 添加首页和尾页
                    list.unshift({txt: 1, val: 1})
                    list.push({txt: this.pages, val: this.pages})
                }
                return list
            }
        },
        methods: {
            setCurrent (idx) {
                if (this.current !== idx && idx > 0 && idx < this.pages + 1) {
                    this.$emit('on-change', idx)
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .fix {
        &::before, &::after {
            content: "";
            width: 100%;
            height: 0;
            visibility: hidden;
            clear: both;
        }
    }
    .l {
        float: left;
    }
    .r {
        float: right;
    }
    .page-box{
        &.center{
            text-align: center;
        }
        .page-wrap{
            display: inline-block;
        }
        .total-des{
            line-height: 38px;
        }
        ul{
            display: inline-block;
            padding: 0 10px;
            margin-bottom: 0;
            li{
                display: inline-block;
                padding: 15px 20px;
                min-width: 48px;
                margin: 0 5px;
                background-color: #fff;
                border-radius: 3px;
                font-size: 14px;
                color: #5a5a5a;
                text-align: center;
                cursor: pointer;
                &:hover {
                    background-color: #ebedf4;
                    color: #5a5a5a;
                }
                &.cur{
                    background-color: #031257;
                    color: #fff;
                    pointer-events: none;
                    cursor: default;
                }
                &.no-event{
                    pointer-events: none;
                    cursor: default;
                }
            }
        }
        .next-page,
        .prev-page {
            display: inline-block;
            border-radius: 3px;
            background-color: #fff;
            font-size: 14px;
            color: #5a5a5a;
            cursor: pointer;
            text-decoration: none;
            &:hover {
                background-color: #ebedf4;
                color: #5a5a5a;
            }
            &.disabled {
                background-color: #fff;
                color: #5a5a5a;
                pointer-events: none;
                cursor: default;
            }
        }
        .next-page {
            padding: 15px 15px 15px 30px;
        }
        .prev-page {
            padding: 15px 30px 15px 15px;
        }
    }
</style>
